// Cypress tests must be updated if these are changed
// Keep cypress/cypress/e2e/pdp/constants.ts in sync
export const RETURN_FAVORITE_TOKEN_NAME = 'add-to-favorites-token';
export const FAVORITE_URL_PARAM_NAME = 'add_to_favorites';

export const RETURN_FOLLOW_ARTIST_TOKEN_NAME = 'follow-artist-token';
export const FOLLOW_ARTIST_URL_PARAM_NAME = 'follow_artist';

export const SIGNUP_LINK_BASE = '/signup';
export const LOGIN_LINK_BASE = '/auth/login';

export const ITEM_TO_FAVORITE = 'item_to_favorite';

export const getSignUpUrl = (returnUrl?: URL | Location) => {
  const getUrlPath = (url: URL | Location) => {
    return [url.pathname, url.search, url.hash].join('');
  };

  const loginUrl = new URL(SIGNUP_LINK_BASE, window.location.href);
  if (returnUrl) {
    loginUrl.searchParams.append('next_action', getUrlPath(returnUrl));
  }

  return getUrlPath(loginUrl);
};

export const getLogInUrl = (returnUrl?: URL | Location) => {
  const getUrlPath = (url: URL | Location) => {
    return [url.pathname, url.search, url.hash].join('');
  };

  const loginUrl = new URL(LOGIN_LINK_BASE, window.location.href);
  if (returnUrl) {
    loginUrl.searchParams.append('next_action', getUrlPath(returnUrl));
  }

  return getUrlPath(loginUrl);
};

export const getReturnToken = (returnToken: string) => {
  return sessionStorage.getItem(returnToken);
};

export const generateAndStoreReturnToken = (returnToken: string) => {
  const existingToken = getReturnToken(returnToken);
  if (existingToken) {
    return existingToken;
  }

  const token = Date.now().toString();
  sessionStorage.setItem(returnToken, token);

  return token;
};

export const verifyReturnToken = (token: string, actionToken: string) => {
  const returnToken = getReturnToken(actionToken);

  return returnToken && returnToken === token;
};
